
/**
 * @summary Enum which represents the Vuex modules avaliable.
 */
export enum Modules {
	Areas = "areas",
    AreaEventHistory = "areaEventHistory",
    CustomFields = "customFields",
    Devices = "devices",
    EventQueue = "eventqueue",
    GenericTable = "GenericTable",
	Reports = "reports",
    SiteMonitor = "siteMonitor",
	Tours = "tours",
    Responses = "responses",
    InvolvedParties = "involvedParties"
}
